import { select, takeLatest, put } from 'redux-saga/effects'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'
import { BurnsConstants } from '../store/burns.constants'
import { IBurnsState } from '../store/burns.types'
import { getBurnsSelector } from '../selectors'
import { sumByKey } from '../../../../../utilities/array.utils'
import { setBurnsTotalCalculations } from '../store/burns.actions'

export function* setBodyAreaCalculations() {
  const burnsStateData: IBurnsState = yield select(getBurnsSelector)
  const { burnsExamData } = burnsStateData
  const BURN_PERCENTAGE = 'burnPercentage'

  // head => total of all degress of head [2]
  // arms => total of all degrees of left / right arm [37 , 38]
  // trunk => total of all degress of chest / lung, pelvis / GU / Genitalia [5,8,9,83]
  // legs => total of all degrees of left / right leg [65 , 66]
  // 1st degree
  // 2nd degree
  // 3rd degree
  // TBSA => total of 2nd & 3rd degree

  const headAnterior = sumByKey(burnsExamData, BURN_PERCENTAGE, { locationId: [2], type: ['A'] })
  const headPosterior = sumByKey(burnsExamData, BURN_PERCENTAGE, { locationId: [2], type: ['P'] })
  const armsAnterior = sumByKey(burnsExamData, BURN_PERCENTAGE, { locationId: [37, 38], type: ['A'] })
  const armsPosterior = sumByKey(burnsExamData, BURN_PERCENTAGE, { locationId: [37, 38], type: ['P'] })
  const trunkAnterior = sumByKey(burnsExamData, BURN_PERCENTAGE, { locationId: [5, 8, 9, 83], type: ['A'] })
  const trunkPosterior = sumByKey(burnsExamData, BURN_PERCENTAGE, { locationId: [5, 8, 9, 83], type: ['P'] })
  const legsAnterior = sumByKey(burnsExamData, BURN_PERCENTAGE, { locationId: [65, 66], type: ['A'] })
  const legsPosterior = sumByKey(burnsExamData, BURN_PERCENTAGE, { locationId: [65, 66], type: ['P'] })
  const firstDegree = sumByKey(burnsExamData, BURN_PERCENTAGE, { burnType: [1] })
  const secondDegree = sumByKey(burnsExamData, BURN_PERCENTAGE, { burnType: [2] })
  const thirdDegree = sumByKey(burnsExamData, BURN_PERCENTAGE, { burnType: [3] })
  const tbsaScore = secondDegree + thirdDegree
  const sumObj = {
    headAnterior,
    headPosterior,
    armsAnterior,
    armsPosterior,
    trunkAnterior,
    trunkPosterior,
    legsAnterior,
    legsPosterior,
    firstDegree,
    secondDegree,
    thirdDegree,
    tbsaScore,
  }
  yield put(setBurnsTotalCalculations(sumObj))
}

export function* setBodyAreaCalculationsSaga() {
  yield takeLatest([BurnsConstants.SET_BODY_AREA_CALCULATION], performWithMutexHOG, setBodyAreaCalculations)
}
